import { render, staticRenderFns } from "./chooseResourceStore4.vue?vue&type=template&id=6a95e1d7&scoped=true"
import script from "./chooseResourceStore4.vue?vue&type=script&lang=js"
export * from "./chooseResourceStore4.vue?vue&type=script&lang=js"
import style0 from "./chooseResourceStore4.vue?vue&type=style&index=0&id=6a95e1d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95e1d7",
  null
  
)

export default component.exports